import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs/Rx';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {RuntimeEnvironment} from '../enums/runtime-environment.enum';
import {ScriptKey} from '../../core/enums/script-key.enum';
import {env} from '../../core/utils/utils';
import {CustomMetricsName} from '../components/models/metrics/custom-metrics-name.enum';
import {MetricsType} from '../components/models/metrics/metrics-type.enum';
import {MetricsService} from './metrics.service';

@Injectable({
  providedIn: 'root'
})
export class LazyLoadingScriptsService {

  private readonly SCRIPTS: ScriptConfig[] = [
    {
      key: ScriptKey.ERUDA_CONSOLE,
      loaded$: new BehaviorSubject<boolean>(false),
      endpoints: [
        {
          env: RuntimeEnvironment.DEV,
          url: './assets/js/eruda.js'
        },
        {
          env: RuntimeEnvironment.TEST,
          url: './assets/js/eruda.js'
        },
        {
          env: RuntimeEnvironment.PROD,
          url: './assets/js/eruda.js'
        }
      ]
    },
  ];

  constructor(private metricsService: MetricsService) { }

  loadScript(key: string, urlSuffix: string = ''): void {
    const config = this.getConfig(key);
    if (isNotNullOrUndefined(config) && !config.initialized) {
      const script = document.createElement('script');
      script.onload = () => {
        this.getConfig(key).initialized = true;
        this.getConfig(key).loaded$.next(true);
      };
      script.onerror = () => {
        this.metricsService.sendSimpleMetric(CustomMetricsName.LOADING_SCRIPT_ERROR, MetricsType.PROCESS, `${this.getEndpoint(key)}${urlSuffix}`);
      }
      script.src = `${this.getEndpoint(key)}${urlSuffix}`;
      document.head.appendChild(script);
    }
  }

  getLoaded(key: string): BehaviorSubject<boolean> {
    const config = this.getConfig(key);
    return config.loaded$;
  }

  private getConfig(key: string): ScriptConfig {
    return this.SCRIPTS.find(scriptConfig => scriptConfig.key === key);
  }

  private getEndpoint(key: string): string {
    const config = this.getConfig(key);
    if (isNotNullOrUndefined(config)) {
      const endpoint = config.endpoints.find(item => item.env === env());
      return endpoint.url;
    }
    return null;
  }
}

interface ScriptConfig {
  key: string;
  loaded$: BehaviorSubject<boolean>;
  initialized?: boolean;
  endpoints: ScriptEndpoint[];
}

interface ScriptEndpoint {
  env: string;
  url: string;
}
